import { render, staticRenderFns } from "./ProgressBasic.vue?vue&type=template&id=4bc285e4&"
import script from "./ProgressBasic.vue?vue&type=script&lang=js&"
export * from "./ProgressBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports